/* eslint-disable no-plusplus */
/* eslint-disable no-bitwise */
/*
 * @Author: chenhe ch10@meitu.com
 * @Date: 2025-09-05 20:26:12
 * @LastEditors: chenhe ch10@meitu.com
 * @LastEditTime: 2025-09-06 18:11:31
 * @FilePath: /roboneo-web/packages/roboneo-sdk/src/utils/fileUtils.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import piexif from 'piexifjs';
import { v4 as uuid } from 'uuid';
// Blob -> Base64
export async function blobToBase64(blob: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;

    reader.readAsDataURL(blob); // data:image/jpeg;base64,...
  });
}

export function base64ToBlob(base64: string) {
  const [header, data] = base64.split(',');
  const mime = header.match(/:(.*?);/)?.[1];
  const binary = atob(data);
  const array = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    array[i] = binary.charCodeAt(i);
  }
  return new Blob([array], { type: mime });
}

export function objectAIGCString() {
  // 生成一个固定格式的ID，类似于成功案例中的格式
  // const generateId = () => {
  //   const timestamp = Date.now();
  //   const random = Math.floor(Math.random() * 1000000);
  //   return `t_mt1a3i${timestamp}${random}`;
  // };

  const uuid1 = uuid();
  const uuid2 = uuid();
  const uuid3 = uuid();
  // const produceId = generateId();

  const aigcObject = {
    AIGC: {
      Label: 1, // 固定1
      ContentProducer: '001191350200737895515300000', // 固定
      ProduceID: uuid3,
      ReservedCode1: uuid1,
      ContentPropagator: '001191350200737895515300000', // 固定
      PropagateID: uuid3, // 使用相同的ID
      ReservedCode2: uuid2,
    },
  };

  // 转成 JSON 字符串
  const jsonStr = JSON.stringify(aigcObject);

  return jsonStr;
}

// jpg图片插入水印元数据
export async function setJpgExifUserComment(blob: Blob) {
  console.log('开始添加EXIF元数据');
  // 转成 base64
  const base64 = await blobToBase64(blob) as string;

  // 取出原有 exif 数据
  const exifObj = piexif.load(base64) as any;
  if (!exifObj.Exif) exifObj.Exif = {};

  // 按照EXIF规范，UserComment需要添加字符集标识符

  // 设置UserComment (37510是UserComment的标签值)
  exifObj.Exif[37510] = objectAIGCString();

  // 插入回去
  const exifBytes = piexif.dump(exifObj);
  const newBase64 = piexif.insert(exifBytes, base64);

  // 转回 Blob
  return base64ToBlob(newBase64);
}

// 计算CRC32（这里使用简化版本，实际应该使用标准CRC32算法）
function crc32(data: Uint8Array): number {
  // 这是一个简化的CRC32实现，实际应用中应使用标准库
  let crc = 0xFFFFFFFF;
  const table = new Array(256);

  for (let i = 0; i < 256; i++) {
    let c = i;
    for (let j = 0; j < 8; j++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[i] = c;
  }

  for (let i = 0; i < data.length; i++) {
    crc = (crc >>> 8) ^ table[(crc ^ data[i]) & 0xFF];
  }

  return crc ^ 0xFFFFFFFF;
}

/**
 * 将 JSON 写入 EXIF UserComment 并以 eXIf 块注入 PNG（Big-endian/MM）
 * - 如果 PNG 已存在 eXIf，则覆盖（跳过旧的并插入新的）
 * - 将 eXIf 插入到 IHDR 之后（或在没有找到 IHDR 的极端情况下，保底在 IEND 之前）
 * @param blob PNG Blob
 * @param json 可选，传入自定义 JSON；不传则使用 objectAIGCToBase64() 生成
 */
export async function setPngExifAIGC(blob: Blob, json?: string) {
  if (blob.type !== 'image/png') return blob;

  // 生成或使用传入的 JSON，务必是 ASCII（默认 objectAIGCToBase64() 为 ASCII 组成）
  const jsonStr = json ?? objectAIGCString();

  // 将字符串按 ASCII 编码为字节
  function asciiBytes(s: string): Uint8Array {
    const arr = new Uint8Array(s.length);
    for (let i = 0; i < s.length; i++) {
      const code = s.charCodeAt(i);
      arr[i] = (code & 0x7F); // 强制 ASCII 范围
    }
    return arr;
  }

  // 写入 BE 数字
  function writeU16BE(view: Uint8Array, off: number, v: number) {
    view[off] = (v >> 8) & 0xFF;
    view[off + 1] = v & 0xFF;
  }
  function writeU32BE(view: Uint8Array, off: number, v: number) {
    view[off] = (v >> 24) & 0xFF;
    view[off + 1] = (v >> 16) & 0xFF;
    view[off + 2] = (v >> 8) & 0xFF;
    view[off + 3] = v & 0xFF;
  }

  // 构造 eXIf 数据区（不含 PNG 块头）
  // 按规范：eXIf chunk 的数据应从 TIFF 头开始（不包含 "Exif\0\0"）
  // 结构: TIFF (MM, 0x002A, IFD0Offset=8) + IFD0(仅 ExifIFDPointer) + SubIFD(ExifVersion=0232, UserComment=ASCII 前缀+JSON) + UserComment数据
  function buildExifData(aigcJson: string): Uint8Array {
    const userCommentPrefix = asciiBytes('ASCII\u0000\u0000\u0000'); // 8字节
    const commentText = asciiBytes(aigcJson);
    const userCommentData = new Uint8Array(userCommentPrefix.length + commentText.length);
    userCommentData.set(userCommentPrefix, 0);
    userCommentData.set(commentText, userCommentPrefix.length);

    // 固定布局大小计算
    const tiffHeaderSize = 8; // 'MM'(2) + 0x002A(2) + IFD0Offset(4)
    const ifd0Entries = 1; // 仅 0x8769 ExifIFDPointer
    const ifd0Size = 2 + ifd0Entries * 12 + 4; // count(2) + entries + nextIFD(4) = 18
    const subIfdEntries = 2; // 0x9000 ExifVersion, 0x9286 UserComment
    const subIfdSize = 2 + subIfdEntries * 12 + 4; // 30
    const dataAreaSize = userCommentData.length;

    const ifd0Offset = tiffHeaderSize; // 8
    const subIfdOffset = ifd0Offset + ifd0Size; // 26
    const userCommentDataOffset = subIfdOffset + subIfdSize; // 56

    const exifPayloadSize = tiffHeaderSize + ifd0Size + subIfdSize + dataAreaSize; // 56 + data
    const totalSize = exifPayloadSize;

    const buf = new Uint8Array(totalSize);

    let p = 0;
    const tiffBase = 0;

    // TIFF Header (MM, 0x002A, IFD0Offset=8)
    buf[p++] = 0x4D; // 'M'
    buf[p++] = 0x4D; // 'M'
    writeU16BE(buf, p, 0x002A); p += 2;
    writeU32BE(buf, p, 8); p += 4; // IFD0 offset from TIFF start

    // IFD0
    writeU16BE(buf, p, ifd0Entries); p += 2;
    // Entry 1: ExifIFDPointer (0x8769), type LONG(4), count=1, value=subIFDOffset
    writeU16BE(buf, p, 0x8769); p += 2; // tag
    writeU16BE(buf, p, 4); p += 2; // type LONG
    writeU32BE(buf, p, 1); p += 4; // count
    writeU32BE(buf, p, subIfdOffset); p += 4; // value

    // next IFD offset = 0
    writeU32BE(buf, p, 0); p += 4;

    // SubIFD
    // 两个条目：ExifVersion(0x9000, UNDEFINED,4,"0232") 与 UserComment(0x9286, UNDEFINED,n, offset)
    writeU16BE(buf, p, subIfdEntries); p += 2;

    // ExifVersion
    writeU16BE(buf, p, 0x9000); p += 2; // tag
    writeU16BE(buf, p, 7); p += 2; // type UNDEFINED
    writeU32BE(buf, p, 4); p += 4; // count=4
    // value bytes: '0','2','3','2'
    buf[p++] = 0x30; // '0'
    buf[p++] = 0x32; // '2'
    buf[p++] = 0x33; // '3'
    buf[p++] = 0x32; // '2'

    // UserComment
    writeU16BE(buf, p, 0x9286); p += 2; // tag
    writeU16BE(buf, p, 7); p += 2; // type UNDEFINED
    writeU32BE(buf, p, userCommentData.length); p += 4; // count = bytes length
    writeU32BE(buf, p, userCommentDataOffset); p += 4; // value = offset to data

    // nextIFD=0
    writeU32BE(buf, p, 0); p += 4;

    // 写入实际的 UserComment 数据到 data 区域
    buf.set(userCommentData, tiffBase + userCommentDataOffset);

    return buf;
  }

  // 创建 PNG chunk: length(4) + type(4) + data + crc(4)
  function createPngChunk(type: string, data: Uint8Array): Uint8Array {
    const typeBytes = asciiBytes(type);
    const crcInput = new Uint8Array(4 + data.length);
    crcInput.set(typeBytes, 0);
    crcInput.set(data, 4);
    const crc = crc32(crcInput);

    const chunk = new Uint8Array(12 + data.length);
    // length
    writeU32BE(chunk, 0, data.length);
    // type
    chunk.set(typeBytes, 4);
    // data
    chunk.set(data, 8);
    // crc
    writeU32BE(chunk, 8 + data.length, crc);

    return chunk;
  }

  // 注入/覆盖 eXIf（最小修改策略）：
  // 1) 若已存在 eXIf：
  //    - 若新旧 chunk 长度一致，原位覆盖，文件长度不变
  //    - 否则，仅做一次前缀 + 新块 + 后缀拼接
  // 2) 若不存在 eXIf：
  //    - 优先在首个 IDAT 之前插入；若无 IDAT，则在 IEND 之前插入
  function injectExif(png: Uint8Array, exifChunk: Uint8Array): Uint8Array {
    // 检查 PNG 签名
    if (
      png.length < 8
      || png[0] !== 0x89 || png[1] !== 0x50 || png[2] !== 0x4E || png[3] !== 0x47
      || png[4] !== 0x0D || png[5] !== 0x0A || png[6] !== 0x1A || png[7] !== 0x0A
    ) {
      return png;
    }

    let offset = 8;
    let firstIDAT = -1;
    let iendOffset = -1;
    let exifStart = -1;
    let exifEnd = -1;

    // 一次遍历定位 eXIf、首个 IDAT 与 IEND
    while (offset + 8 <= png.length) {
      const length = (png[offset] << 24) | (png[offset + 1] << 16) | (png[offset + 2] << 8) | png[offset + 3];
      const typeStart = offset + 4;
      const typeA = png[typeStart];
      const typeB = png[typeStart + 1];
      const typeC = png[typeStart + 2];
      const typeD = png[typeStart + 3];
      const typeStr = String.fromCharCode(typeA, typeB, typeC, typeD);

      const chunkTotal = 12 + length;
      const chunkEnd = offset + chunkTotal;
      if (chunkEnd > png.length) {
        // 损坏，返回原图
        return png;
      }

      if (typeStr === 'eXIf' && exifStart === -1) {
        exifStart = offset;
        exifEnd = chunkEnd;
      } else if (typeStr === 'IDAT' && firstIDAT === -1) {
        firstIDAT = offset;
      } else if (typeStr === 'IEND') {
        iendOffset = offset;
        // 遇到 IEND 可以结束
        break;
      }

      offset = chunkEnd;
    }

    // 若存在 eXIf：尝试原位覆盖
    if (exifStart !== -1 && exifEnd !== -1) {
      const oldLen = exifEnd - exifStart;
      if (oldLen === exifChunk.length) {
        // 原位覆盖，长度不变
        const out = new Uint8Array(png.length);
        out.set(png, 0);
        out.set(exifChunk, exifStart);
        return out;
      }
      // 长度不同：做一次拼接
      const out = new Uint8Array(png.length - oldLen + exifChunk.length);
      // 前缀
      out.set(png.subarray(0, exifStart), 0);
      // 新 eXIf
      out.set(exifChunk, exifStart);
      // 后缀
      out.set(png.subarray(exifEnd), exifStart + exifChunk.length);
      return out;
    }

    // 不存在 eXIf：选择插入点（首选 IDAT 前，其次 IEND 前）
    let insertPos = -1;
    if (firstIDAT !== -1) insertPos = firstIDAT;
    else if (iendOffset !== -1) insertPos = iendOffset;
    else insertPos = png.length; // 兜底：追加到末尾

    const out = new Uint8Array(png.length + exifChunk.length);
    // 前缀
    out.set(png.subarray(0, insertPos), 0);
    // eXIf
    out.set(exifChunk, insertPos);
    // 后缀
    out.set(png.subarray(insertPos), insertPos + exifChunk.length);
    return out;
  }

  try {
    const buf = new Uint8Array(await blob.arrayBuffer());
    // 构建 eXIf 数据与 PNG eXIf 块
    const exifData = buildExifData(jsonStr);
    const exifChunk = createPngChunk('eXIf', exifData);

    const updated = injectExif(buf, exifChunk);
    return new Blob([updated], { type: 'image/png' });
  } catch (e) {
    console.error('写入 PNG eXIf 失败:', e);
    return blob;
  }
}
